export interface PublishTaskSettings {
  accountId?: string;
  platformType?: number;
  publishMode?: 'immediate' | 'scheduled' | 'delay';
  publishAt?: string;
  delayMinutes?: number;
  intervalMinutes?: number;
  mediaVariableId?: string;
  requestVariableId?: string;
}

export interface PublishPromptMetadata extends PublishTaskSettings {
  prompt?: string;
  query?: string;
  taskPrompts?: Record<string, string>;
  taskSettings?: Record<string, PublishTaskSettings>;
  publishTargets?: Array<{ platformType?: number; userPrompt?: string } & PublishTaskSettings>;
}

export function resolvePublishTaskSettings(
  metadata: PublishPromptMetadata,
  accountId: string,
  platformType?: number,
): PublishTaskSettings {
  const target = metadata.publishTargets?.find(
    (item) => Number(item.platformType) === Number(platformType),
  );
  const override = metadata.taskSettings?.[accountId];
  const source = { ...metadata, ...target, ...override };
  const scheduleSource = [override, target, metadata].find((item) => item &&
    (item.publishMode !== undefined || item.publishAt !== undefined || item.delayMinutes !== undefined));
  return {
    accountId: source.accountId,
    platformType: source.platformType,
    publishMode:
      scheduleSource?.publishMode ??
      (scheduleSource?.publishAt ? 'scheduled' : scheduleSource?.delayMinutes ? 'delay' : 'immediate'),
    publishAt: scheduleSource?.publishAt,
    delayMinutes: scheduleSource?.delayMinutes ?? 0,
    intervalMinutes: source.intervalMinutes ?? 0,
    mediaVariableId: source.mediaVariableId ?? '',
    requestVariableId: source.requestVariableId ?? '',
  };
}

export function resolvePublishTaskPrompt(
  metadata: PublishPromptMetadata,
  accountId: string,
  platformType?: number,
): string {
  const override = metadata.taskPrompts?.[accountId];
  if (typeof override === 'string') return override;
  const target = metadata.publishTargets?.find(
    (item) => Number(item.platformType) === Number(platformType),
  );
  return target?.userPrompt ?? metadata.prompt ?? metadata.query ?? '';
}
